import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-never-logged',
  templateUrl: './bar-chart-never-logged.component.html',
  styleUrls: ['./bar-chart-never-logged.component.css']
})
export class BarChartNeverLoggedComponent implements OnInit, OnDestroy {
  //
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  isHovered = false;
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;

  title = "Accesso non effettuato";
  destination = 'general-status';
  // tabella degli elementi che non hanno mai effettuato il login
  isTableLoginAvailable = false; // tabella di coloro che non hanno mai effettuato il Login
  isDataAvailable = false;

  dataSource;
  headElementsNeverLogged = ['select', 'name', 'surname'];
  // ******************************************************************************************************************
  // pginators
  // ******************************************************************************************************************
  // paginator Never Logged
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  public totalSize = 0;
  //
  // selezione Never Logged
  selectedNeverLogged = false;
  // checked = false;
  selection = false;
  patientNeverLoggedMails: string[] = [];
  // ******************************************************************************************************************
  // inizializzazione never logged Patients ( NUMERO )
  // ******************************************************************************************************************
  neverLoggedPatients = []; // solo il numero per il chart
  otherLogged = [];
  neverLoggedArray = []; // array con pazienti che non hanno mai effettuato il login

  // ******************************************************************************************************************
  // inizializzazione pazienti totali
  // ******************************************************************************************************************
  allAPatients = 0;
  allCPatients = 0;
  allUCPatients = 0;
  totalPatients = 0;
  public barChartLabelsNeverLogged = ['LOGIN UTENTI'];
  public barChartTypeNeverLogged = 'horizontalBar';
  //global barChartData
  public barChartDataNeverLogged = [{
    data: this.neverLoggedPatients,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: '#f00',
    hoverBackgroundColor: '#c00',
    label: 'Accesso non effettuato',
    datalabels: {
      color: 'white' // Color for percentage value
    }
  }, {
    data: this.otherLogged,
    backgroundColor: 'lightgrey',
    hoverBackgroundColor: '#808080',
    barThickness: 70,  // number (pixels) or 'flex'
    label: 'Accesso effettuato',
    datalabels: {
      color: 'lightgray' 			// Make the color of the second bar percentage value same as the color of the bar
    }
  }];
  //fine globalBarChartData

  canvas: any;
  ctx: any;

  myChartNeverLogged: Chart;
  myChartNeverLoggedTelemedicine: Chart;

  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }
  // constructor
  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private snackBar: MatSnackBar) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription3 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievedata();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }
  // funzioni per i numeri globali dei pazienti in base alla malattia, sia per i pazienti personali e
  // globali ( doughnut chart)

  retrievedata() {
    this.subscription1 = this.doctorService.getAllPatientsNumber().subscribe(
      AllPatientsNumber => {
        this.totalPatients = parseInt(AllPatientsNumber.toString());
        this.retrieveNeverLogged();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }
  // never logged patients (registration time before of 2 weeks and lastLogin == null)
  retrieveNeverLogged() {
    this.subscription2 = this.doctorService.getNeverLogged().subscribe(patients => {
      this.neverLoggedPatients.push(Object.keys(patients).length);
      this.otherLogged.push(this.totalPatients - Object.keys(patients).length);

            // riempio il vettore che serve per la tabella
            Object.keys(patients).forEach(patient => {
              this.neverLoggedArray.push(patients[patient]);});
      //inizio1
      this.canvas = document.getElementById('myChartNeverLogged') as HTMLCanvasElement;
      this.ctx = this.canvas.getContext('2d');
      this.myChartNeverLogged = new Chart(this.ctx, {
        type: this.barChartTypeNeverLogged,
        data: {
          labels: this.barChartLabelsNeverLogged,
          datasets: this.barChartDataNeverLogged,
        },
        options: {
          responsive: true,
          onClick: event => {
            if (this.myChartNeverLogged.getElementAtEvent(event).length > 0) {
              if (this.myChartNeverLogged.getElementAtEvent(event)[0]['_model'].datasetLabel === 'Accesso non effettuato') {
                this.showTableNeverLogged();
              }
            }
          },
          onHover: (event) => {
            if (this.myChartNeverLogged.getElementAtEvent(event).length > 0) {
              if (this.myChartNeverLogged.getElementAtEvent(event)[0]['_model'].datasetLabel === 'Accesso non effettuato') {
                this.setHoverVariable();
              } else {
                this.unsetHoverVariable();
              }
            }
          },
          scales: {
            xAxes: [{
              display: true,
              stacked: true,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
            yAxes: [{
              display: false,
              stacked: true,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
          },
          legend: {
            onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
              // tslint:disable-next-line:max-line-length
              if (legendItem.text.length > 0 && (legendItem.text === 'Accesso non effettuato' || legendItem.text === 'Accesso effettuato')) {
                this.setHoverVariable();
              } else {
                this.unsetHoverVariable();
              }
            },
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              fontColor: '#006192',
              fontSize: 18,
              fontFamily: 'Helvetica',
            }
          },
          tooltips: {
            // content: '{pathology}: {number}',
            backgroundColor: '#1c1c1c',
            bodyFontSize: 18,
            titleFontSize: 18,
            cornerRadius: 5,
            caretPadding: 10
          },
          title: {
            display: true,
            text: 'N° di utenti che hanno/non hanno effettuato il login',
            fontColor: '#006192',
            fontSize: 20,
            fontFamily: 'Helvetica',
          },
          hover: {
            mode: 'nearest',
            intersect: true
          }
        }


      });
    //fine1

      // setto correttamente il paginator
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    }
    
    );

    this.isDataAvailable = true;

  }

  
  // pagination della tabella di coloro che non hanno mai effettuato il login
  // paginazione effettuata manualmente
  getPagination() {
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = this.neverLoggedArray;
    // this.dataSource.paginator = this.paginator;

    this.tasks = this.neverLoggedArray;
    //this.tasks = this.neverLoggedStandardArray;
    this.totalSize = this.tasks.length;
    this.currentPage = 0;
    this.iterator();
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable of Never Logged
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable of Never Logged
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  // show table never logged patients
  showTableNeverLogged(): void {
    if (this.isHovered === true) {
      if (this.isTableLoginAvailable === true) {
        this.isTableLoginAvailable = false;
      } else {
        this.getPagination();
        this.isTableLoginAvailable = true;
      }
    }
  }
  // nasconde la tabella dei never logged
  hideTableLogin() {
    this.isTableLoginAvailable = false;
  }
  // METODI PER I CHECKOUT DEI NEVER LOGGED PATIENTS
  // metodo che permette di selezionare tutti gli utenti che non hanno mai effettuato l'accesso
  // e che viene invocato al 'change' della selezione
  selectAllNeverLogged(event: MatCheckboxChange): void {
    if (event.checked === true) { // se voglio selezionarli tutti il 'checked' è impostato su 'true'
      this.neverLoggedArray.forEach(val => { // in questo caso è necessario mettere ogni check-box 'false'
        // per come è stato costruito il metodo
        val.checked = false;
      });
    } else {
      this.neverLoggedArray.forEach(val => { // se voglio deselezionarli tutti il checked è impostato su'false'
        val.checked = true; // è necessario mettere ogni check-box 'true' per come è stato costruito il metodo
      });
    }
    // ogni volta inizializzo il vettore contenente le mail vuoto (evito così che ci siano mail ripetute più volte se
    // già selezionate singolarmente prima di cliccare 'seleziona tutti')
    this.patientNeverLoggedMails = [];
    this.selectedNeverLogged = true; // questo serve per l'html, per non ricadere nell' #elseBlock del template
    //
    // se tutti i check-box sono su 'true' metto tutte le mail in un array
    if (this.neverLoggedArray.every(val => val.checked === true)) { // se voglio eliminarli tutti
      this.neverLoggedArray.forEach(val => {
        val.checked = false;
        this.patientNeverLoggedMails.pop(); // li elimino uno alla volta
      });
      console.log(this.patientNeverLoggedMails); // controllo in console
    } else { // se voglio selezionarli tutti e quindi se tutti i check-box sono impostati su 'false'
      this.neverLoggedArray.forEach(val => {
        val.checked = true;
        this.patientNeverLoggedMails.push(val.email); // inserisco le mail nell'array una alla volta
      });
      console.log(this.patientNeverLoggedMails); // controllo in console
    }
  }
  // metodo che permette di eliminare o aggiungere indirizzi mail nel caso in cui gli utenti siano tutti selezionati
  changeNeverLoggedItem(event: MatCheckboxChange, element): void {
    if (event.checked === false) { // se il check-box è deselezioneto allora si toglie la mail dalla lista
      this.patientNeverLoggedMails = this.patientNeverLoggedMails.filter(item => item !== element.email);
      console.log(this.patientNeverLoggedMails); // controllo in console
    } else { // se il check-box è selezionato si mette nella lista
      this.patientNeverLoggedMails.push(element.email);
      console.log(this.patientNeverLoggedMails); // controllo in console
    }
  }
  // metodo che viene richiamato nel template #elseBlock nel caso in cui si vogliano selezionare solo alcuni utenti
  selectNeverLoggedItems(event: MatCheckboxChange, element): void {
    this.selectedNeverLogged = false; // si pone a false
    if (event.checked === true) {
      this.patientNeverLoggedMails.push(element.email); // inserisco la mail nella lista
      console.log(this.patientNeverLoggedMails);
    } else {
      this.patientNeverLoggedMails = this.patientNeverLoggedMails.filter(item => item !== element.email); // tolgo la mail dalla lista
      console.log(this.patientNeverLoggedMails);
    }
  }
  // send an email to inactive patients or never logged ones
  sendMailNeverLogged() {
    this.doctorService.sendMailtoInactive(this.patientNeverLoggedMails).subscribe(response => {
      if (response.status === 200) {
        this.snackBar.open('E-mail inviata/e correttamente!', 'Chiudi', {
          duration: 3000});
      } else {
        this.snackBar.open('Qualcosa è andato storto!', 'Chiudi', {
          duration: 3000});
      }
    });
  }

}
